import Vue from 'vue'
import Router from 'vue-router'
import Index from './views/Index.vue'
import Question from './views/Question.vue'
import Result from './views/Result.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
    },
    {
      path: '/question',
      name: 'question',
      component: Question,
    },
    {
      path: '/result',
      name: 'result',
      component: Result,
    },
  ]
})
